/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]     metromap{display:block;width:auto;height:30vh}[_nghost-%COMP%]     waterway-timeline{display:block;height:59vh}.btn-icn[_ngcontent-%COMP%]{width:100%;height:2vh;fill:#000}"];
export { styles as styles };
